var core  = require('./$').core
  , $iter = require('./$.iter');
core.isIterable  = $iter.is;
core.getIterator = $iter.get;


/*****************
 ** WEBPACK FOOTER
 ** /code/~/core-js/library/modules/core.iter-helpers.js
 ** module id = 458
 ** module chunks = 0
 **/